import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import { successChatbot, failureChatbot } from "./ChatbotSlicer";
import { IChatbot } from "../../../Components/Chatbot/IChatbot";
import apichatbot from "../../Axios/middlewareSecond";
import {
  failureWritingChatbot,
  successWritingChatbot,
} from "./WritingChatbotSlicer";
import api from "../../Axios/middleware";

const ChatbotApi = (action: PayloadAction<IChatbot>) => {
  return apichatbot.post("/api/gpt/chat", action.payload);
};

export function* ChatbotCall(action: PayloadAction<IChatbot>) {
  try {
    const respons: AxiosResponse = yield call(ChatbotApi, action);
    yield put(successChatbot(respons.data));
  } catch (error) {
    yield put(failureChatbot(error));
  }
}

const WritingChatbotApi = (action: PayloadAction<IChatbot>) => {
  return api.post("/api/exam/review-ai-writing", action.payload);
};

export function* WritingChatbotCall(action: PayloadAction<IChatbot>) {
  try {
    const response: AxiosResponse = yield call(WritingChatbotApi, action);
    yield put(successWritingChatbot(response.data));
    console.log(response.data, " api chat checkup");
  } catch (error) {
    yield put(failureWritingChatbot(error));
  }
}
